import { ulid } from "ulid";
import { actionGroupUtils, IActionGroup } from "../action/IActionGroup.intf";
import { ITriggerGroup, triggerGroupUtils } from "../trigger/ITriggerGroup.intf";
import { createMergeToDefaultData } from "../utils/mergeToDefaultData";
export interface ITriggerAction{
    type:string
    id:string,
    name:string,
    triggerGroup:ITriggerGroup
    actionGroup:IActionGroup
}


export function createDefultTriggerAction():ITriggerAction{
    return {
        type:'triggerAction',
        id:ulid(),
        name:'',
        triggerGroup:triggerGroupUtils.createDefultData(),
        actionGroup:actionGroupUtils.createDefultData()
    }
}   

export interface ITriggerActionUtils{
    type:string
    createDefultData:()=>ITriggerAction
    mergeDataToDefultData:(data:Partial<ITriggerAction>)=>ITriggerAction
}

export function createTriggerActionUtils(type:string, createDefultData:()=>ITriggerAction):ITriggerActionUtils{
    return {
        type,
        createDefultData,
        mergeDataToDefultData:createMergeToDefaultData(createDefultData)
    }
}   

